export default __webpack_public_path__ + "abf1314c8dc7c1ba3eb181b2160ae619.png";